import { render, staticRenderFns } from "./UserActionsTable.vue?vue&type=template&id=1c928855&scoped=true&"
import script from "./UserActionsTable.vue?vue&type=script&lang=js&"
export * from "./UserActionsTable.vue?vue&type=script&lang=js&"
import style0 from "./UserActionsTable.vue?vue&type=style&index=0&id=1c928855&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c928855",
  null
  
)

export default component.exports